<template>

  <!-- Финансовые блоки -->
  <values-blocks :archive-sum-price="sumPrice" :blocks="valuesBlocks"></values-blocks>

  <!-- Заголовок -->
  <h1 class="mb-4 pl-4 flex justify-between">
    {{ $route.meta.title }}
    <div class="flex items-center right-control">
      <span @click="download(localList)" class="cursor-pointer">
        <svg class="mr-2" id="fi_10260256" enable-background="new 0 0 512 512" width="18" height="18" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g id="Layer_2_00000071524753247990202880000000168808203810262155_"><g id="Layer_1-2"><g id="CSV"><g id="File"><path d="m302.2 0h-191.1c-18.4 0-33.4 15-33.4 33.5v445.1c0 18.5 15 33.4 33.5 33.5h335.5c18.5 0 33.4-15 33.5-33.5l-1-330.6z" fill="#4eb3f2"></path><path d="m302.2 0-.5 144.5s.5 3.5 3.5 3.5h174z" fill="#07c"></path></g><path d="m45.5 246.7h337.6c7.5 0 13.6 6.1 13.6 13.6v150.8c0 7.5-6.1 13.6-13.6 13.6h-337.6c-7.5 0-13.6-6.1-13.6-13.6v-150.8c0-7.5 6.1-13.6 13.6-13.6z" fill="#07c"></path><g fill="#fff"><path d="m150.1 343.4 20.3 6.1c-1.1 5.2-3.3 10-6.4 14.2-2.8 3.8-6.6 6.7-10.9 8.6s-9.9 2.9-16.6 2.9c-8.1 0-14.8-1.2-20-3.5s-9.6-6.5-13.3-12.5-5.6-13.6-5.6-22.9c0-12.4 3.3-21.9 9.9-28.6s15.9-10 28-10c9.4 0 16.9 1.9 22.2 5.7 5.4 3.8 9.4 9.7 12 17.6l-20.4 4.5c-.5-1.8-1.2-3.5-2.2-5-1.2-1.7-2.9-3.1-4.8-4.1-2-1-4.1-1.5-6.3-1.4-4.8-.2-9.4 2.2-12 6.3-2.1 3.1-3.2 8-3.2 14.8 0 8.3 1.3 14 3.8 17.1s6 4.6 10.6 4.7c4.4 0 7.8-1.2 10-3.7 2.2-2.4 3.8-6 4.9-10.8z"></path><path d="m177.6 349.3 22-1.4c.5 3.6 1.4 6.3 2.9 8.2 2.4 3 5.8 4.5 10.2 4.5 3.3 0 5.9-.8 7.6-2.3 1.7-1.3 2.7-3.3 2.7-5.4 0-2-1-3.9-2.6-5.2-1.7-1.5-5.6-3-11.9-4.4-10.1-2.3-17.4-5.3-21.7-9.1-4.3-3.6-6.7-8.9-6.5-14.5 0-3.9 1.2-7.7 3.4-10.9 2.5-3.6 6-6.4 10.1-8.1 4.5-2 10.6-2.9 18.4-2.9 9.6 0 16.9 1.8 21.9 5.3s8 9.2 9 17l-21.8 1.3c-.6-3.4-1.8-5.8-3.6-7.4-1.9-1.5-4.4-2.3-7.7-2.3-2.7 0-4.7.6-6.1 1.7-1.3 1-2.1 2.5-2.1 4.2 0 1.3.7 2.5 1.7 3.2 1.1 1 3.7 1.9 7.8 2.8 10.1 2.2 17.4 4.4 21.7 6.6 3.9 1.8 7.2 4.7 9.6 8.3 2 3.3 3 7.2 3 11.1 0 4.7-1.4 9.4-4 13.3-2.7 4.1-6.6 7.3-11.1 9.2-4.8 2.1-10.8 3.1-18 3.1-12.7 0-21.6-2.5-26.5-7.4-5-4.8-8-11.5-8.4-18.5z"></path><path d="m249.8 299.1h24.2l16.9 53.9 16.6-53.9h23.5l-27.8 74.9h-25.1z"></path></g></g></g></g></svg>
      </span>
      <flat-pickr v-model="date" :config="dateConfig" class="form-control"/>
    </div>
  </h1>

  <!-- Список задач -->
  <div class="block">
    <table-component :list="localList" type="tasks-archive" @row-click="handleTaskClick">
      <tr>
        <th style="width: 58px; padding-left: 10px; padding-right: 0"><span class="opacity-20">#</span></th>
        <th style="min-width: 50%">Название</th>
        <th class="w-48">Оценка</th>
        <th class="w-48">Дата закрытия</th>
      </tr>
    </table-component>
  </div>

</template>

<script>
import { useTasksStore } from '@/stores/tasks'
import { useFinStore } from '@/stores/fin'
import { useCompanyStore } from '@/stores/company'
import { useTaskDetailDialogStore } from '@/stores/taskDetailDialog'
import { mapState, mapStores } from 'pinia/dist/pinia'
import TableComponent from '@/components/table/TableComponent'
import ValuesBlocks from '@/components/ValuesBlocks'
import Csv from '@/classes/csv'

// Календарь
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/themes/material_blue.css'
import { Russian } from 'flatpickr/dist/l10n/ru.js'

export default {
  name: 'TaskListArchive',
  props: ['filterStatus', 'valuesBlocks'],
  components: {
    ValuesBlocks,
    TableComponent,
    flatPickr,
  },
  data () {
    return {
      dateStart: '2030-01-01T00:00:00+03:00',
      dateEnd: '2030-01-01T23:59:59+03:00',
      date: '',
      dateConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        mode: 'range',
        altFormat: 'j M',
        altInput: true,
        dateFormat: 'd.m.Y',
        locale: Russian,
      },
    }
  },
  computed: {
    ...mapStores(useTaskDetailDialogStore),
    ...mapState(useTasksStore, ['list', 'statusList']),
    ...mapState(useFinStore, ['balance', 'debt', 'hourlyRate']),
    ...mapState(useCompanyStore, ['sysObject']),
    localList () {
      const startDate = new Date(this.dateStart);
      const endDate = new Date(this.dateEnd);

      // Фильтруем
      let list = this.list.filter(item => {
        const itemDate = new Date(item.dateClosed)

        if (!this.date) {
          return this.filterStatus.indexOf(item.status) >= 0
        }

        return this.filterStatus.indexOf(item.status) >= 0 && itemDate >= startDate && itemDate <= endDate;
      })

      return list.sort((a, b) => {
        // Преобразуем строки дат в объекты Date
        const dateA = new Date(a.dateClosed);
        const dateB = new Date(b.dateClosed);
        // Возвращаем разницу между датами для сортировки по возрастанию
        return dateA - dateB;
      })
    },
    sumPrice() {
      let sum = 0
      this.localList.forEach(item => {
        sum += item.price
      })
      return sum
    }
  },
  watch: {
    date(newDate) {
      if (!/\d+\.\d+\.\d+ — \d+\.\d+\.\d+/.test(newDate)) {
        newDate = newDate + ' — ' + newDate
      }

      // Разделяем строку на две части по символу '—'
      const dates = newDate.split(' — ');

      // Преобразуем и присваиваем переменным
      this.dateStart = this.toISOFormat(dates[0].trim(), '00:00:00');
      this.dateEnd = this.toISOFormat(dates[1].trim(), '23:59:59');
    }
  },
  methods: {
    download: Csv.download,
    async handleTaskClick(task) {
      await this.taskDetailDialogStore.openTaskDetail(task, this.sysObject)
    },
    toISOFormat(localDate, time) {
      // Разбиваем входную строку на день, месяц и год
      const [day, month, year] = localDate.split('.')

      // Создаем объект Date
      const date = new Date(year, month - 1, day)

      // Получаем смещение часового пояса в минутах
      const timezoneOffset = date.getTimezoneOffset()

      // Преобразуем смещение в часы и минуты
      const offsetHours = Math.abs(Math.floor(timezoneOffset / 60))
      const offsetMinutes = Math.abs(timezoneOffset % 60)

      // Формируем строку смещения часового пояса
      const timezoneString = (timezoneOffset > 0 ? '-' : '+') +
          String(offsetHours).padStart(2, '0') + ':' +
          String(offsetMinutes).padStart(2, '0')

      // Возвращаем дату в формате ISO с локальным смещением часового пояса
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${time}${timezoneString}`
    },
    setCurrentMonth () {
      // Получаем текущую дату
      const now = new Date()

      // Проверяем, меньше ли текущий день или равен четвертому
      if (now.getDate() <= 3) {
        // Если да, устанавливаем дату на первый день предыдущего месяца
        now.setMonth(now.getMonth() - 1)
      }

      // Получаем первый день текущего или предыдущего месяца
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)

      // Получаем последний день текущего или предыдущего месяца
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)

      // Функция для форматирования даты в формат DD.MM.YYYY
      function formatDate (date) {
        const day = date.getDate().toString().padStart(2, '0')
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const year = date.getFullYear()
        return `${day}.${month}.${year}`
      }

      // Форматируем даты и объединяем их в строку
      this.date = `${formatDate(firstDay)} — ${formatDate(lastDay)}`
    },
  },
  mounted () {
    this.setCurrentMonth()
  },
}
</script>

<style>
.right-control {
  font-weight: normal;
  font-size: 14px;
}
.form-control {
  padding: 5px 9px;
  box-shadow: 0 0 1px 0 rgba(0,0,0,.6);
  border-radius: 4px;
  text-transform: lowercase;
  width: 130px;
  margin-top: -1px;
}
</style>
